module.exports = __webpack_public_path__ + "static/media/iconAbsencesF.1a95a266.svg";